module.exports = __webpack_public_path__ + "img/block-a-3.f02e3d88.jpg";